import { useCallback } from 'react'
import { useActivityTypesContext } from '../../../context'
import { createActivityType, updateActivityType } from '../../../effects'
import { closeActivityTypeFormActionCreator } from '../../../state'
import { useIsUnmounted } from '@sales-center/components'

export function useHandlers() {
  const [, dispatch] = useActivityTypesContext()
  const isUnmounted = useIsUnmounted()

  const handleCloseClick = useCallback(() => {
    dispatch(closeActivityTypeFormActionCreator())
  }, [dispatch])

  const handleSubmit = useCallback(
    async (model) => {
      const { id, ...createModel } = model
      const action = id
        ? await updateActivityType(model)
        : await createActivityType(createModel)

      if (isUnmounted()) return

      dispatch(action)
    },
    [dispatch, isUnmounted],
  )

  return {
    handleCloseClick,
    handleSubmit,
  }
}
